/**
 * Вычисляет длительность GIF в секундах по задержкам кадров (Graphics Control Extension).
 * Задержки хранятся в блоках 0x21 0xF9 0x04, 2 байта little-endian в сотых долях секунды.
 */
export async function getGifDurationSeconds(source: File | string): Promise<number> {
  let buffer: ArrayBuffer;
  if (typeof source === 'string') {
    const res = await fetch(source);
    if (!res.ok) return 0;
    buffer = await res.arrayBuffer();
  } else {
    buffer = await source.arrayBuffer();
  }
  const bytes = new Uint8Array(buffer);
  let totalCentiseconds = 0;
  for (let i = 0; i < bytes.length - 6; i++) {
    if (bytes[i] === 0x21 && bytes[i + 1] === 0xf9 && bytes[i + 2] === 0x04) {
      const delayLow = bytes[i + 4];
      const delayHigh = bytes[i + 5];
      const delayCentiseconds = delayLow | (delayHigh << 8);
      totalCentiseconds += delayCentiseconds;
    }
  }
  return totalCentiseconds > 0 ? totalCentiseconds / 100 : 0;
}
